<script>
	import { onMount } from "svelte";

	export let breakpoint = "xs";
	export let width = 0;
	export let elementHeight = 0;
	export let showBreakpoint = false;
	export let elementId = "main-app-header";

	const getBreakpoint = () => {
		if (window.matchMedia("(min-width: 1536px)").matches) return "2xl";
		if (window.matchMedia("(min-width: 1280px)").matches) return "xl";
		if (window.matchMedia("(min-width: 1024px)").matches) return "lg";
		if (window.matchMedia("(min-width: 768px)").matches) return "md";
		if (window.matchMedia("(min-width: 640px)").matches) return "sm";
		return "xs";
	};

	const update = () => {
		breakpoint = getBreakpoint();
		width = window.innerWidth;

		const elem = document.getElementById(elementId);
		elementHeight = elem ? elem.getBoundingClientRect().height : 0;
	};

	onMount(() => {
		update();
		window.addEventListener("resize", update, { passive: true });
		return () => window.removeEventListener("resize", update);
	});
</script>

{#if showBreakpoint}
	<h1>Current Breakpoint: {breakpoint}</h1>
	<h1>Screen Width: {width}px</h1>
{/if}
